import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

export function useResizable(ref, callback) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        callbackRef.current?.(entries[0].contentRect);
      });
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref]);
}
export default function Resizable({
  as: As = 'div',
  onResize = () => {},
  children = [],
}) {
  const ref = useRef();

  useResizable(ref, onResize);

  return <As ref={ref}>{children}</As>;
}

Resizable.propTypes = {
  // Component could be HTML element only, not a custom component.
  as: PropTypes.string,
  onResize: PropTypes.func.isRequired,
  children: PropTypes.node,
};

Resizable.defaultProps = {
  children: [],
};
